export default __webpack_public_path__ + "static/media/Web-full-logo3x.996644a1.png";